import { isMappingSame } from "../../../models/model-utils"

export default function buildMappingsPresentationReducer(
    actionTypes,
    updateChangeModel,
    updateCreateModel,
    canSave
) {
    const {
        ADD_MAPPING,
        REMOVE_MAPPING,
        MAPPING_PREVIEW_REQUEST,
        MAPPING_DELETE_PREVIEW_REQUEST,
        MAPPING_PREVIEW_ERROR_RESPONSE,
        MAPPING_PREVIEW_RESPONSE,
    } = actionTypes
    return (state, action) => {
        const { type, concept } = action
        const updateModelFunction = state.isCreateMode
            ? updateCreateModel
            : updateChangeModel
        switch (type) {
            case ADD_MAPPING: {
                const mappingToBeAdded = { positive: [concept] }
                const doesMappingExist = state.workingModel.mappings.find(
                    (mapping) => isMappingSame(mapping, mappingToBeAdded)
                )
                if (doesMappingExist) {
                    return state
                }
                const workingModelMappings = state.workingModel.mappings.concat(
                    [mappingToBeAdded]
                )
                const updatedWorkingModel = state.workingModel.set(
                    "mappings",
                    workingModelMappings
                )
                const updatedChangeModel = updateModelFunction(
                    "mappings",
                    workingModelMappings,
                    state.updateModel,
                    state.workingModel
                )
                return {
                    ...state,
                    workingModel: updatedWorkingModel,
                    updateModel: updatedChangeModel,
                    canSave: canSave(
                        updatedChangeModel,
                        state.imageToUpload,
                        updatedWorkingModel
                    ),
                }
            }
            case REMOVE_MAPPING: {
                const { mapping } = action
                const workingModelMappings = state.workingModel.mappings.filter(
                    (storedMapping) => !isMappingSame(storedMapping, mapping)
                )
                const updatedWorkingModel = state.workingModel.set(
                    "mappings",
                    workingModelMappings
                )
                const updateModel = updateModelFunction(
                    "mappings",
                    workingModelMappings,
                    state.updateModel,
                    state.workingModel
                )
                return {
                    ...state,
                    workingModel: updatedWorkingModel,
                    updateModel,
                    mappingToBeDeleted: mapping,
                    canSave: canSave(
                        updateModel,
                        state.imageToUpload,
                        updatedWorkingModel
                    ),
                }
            }
            case MAPPING_PREVIEW_REQUEST:
            case MAPPING_DELETE_PREVIEW_REQUEST:
                return {
                    ...state,
                    isFetchingPreview: true,
                    mappingPreview: null,
                }
            case MAPPING_PREVIEW_RESPONSE:
                const {
                    before_count,
                    added_count,
                    added,
                    removed_count,
                    removed,
                } = action
                return {
                    ...state,
                    isFetchingPreview: false,
                    mappingPreview: {
                        beforeCount: before_count,
                        afterCount:
                            (added_count || 0) +
                            before_count -
                            (removed_count || 0),
                        after: added || removed,
                    },
                }
            case MAPPING_PREVIEW_ERROR_RESPONSE:
                return {
                    ...state,
                    isFetchingPreview: false,
                    mappingPreview: null,
                }
            default:
                return state
        }
    }
}
